import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import tableColumns from './customer-order-item-scraper-table-columns'

const propTypes = {
  data                : PropTypes.array,
  pagination          : PropTypes.object,
  onFetchData         : PropTypes.func,
  onChangeOrderStatus : PropTypes.func,
  hiddenColumns       : PropTypes.arrayOf(PropTypes.string),
  isLoading           : PropTypes.bool
}

const defaultProps = {
  onChangeOrderStatus : () => {},
  isLoading           : false
}

/**
 * Table to display specific Seller Inbound columns for receiving
 * @param {Array<Object>} data - array of seller_inbound objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */

const CustomerOrderItemScraperTable = ({
  data,
  pagination,
  onFetchData,
  onChangeOrderStatus,
  hiddenColumns,
  isLoading
}) => {
  const columns = useMemo(
    () => tableColumns({ onChangeOrderStatus }),
    [ onChangeOrderStatus ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

CustomerOrderItemScraperTable.propTypes    = propTypes
CustomerOrderItemScraperTable.defaultProps = defaultProps

export default CustomerOrderItemScraperTable
